import { loadable, memoed } from '@library/react-toolkit'
import { record } from 'fp-ts'
import { pipe } from 'fp-ts/lib/function'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import StatisticWithDate from './StatisticWithDate'

type Props = { type: 'due' | 'paid' }

const AmountCard = ({ type }: Props) => {
  const { loading, amount, period } = useSelector(s => ({
    loading: loadable.isLoading(s.home.periodInfo.v),
    amount: pipe(
      memoed.extract(s.home.currentPeriodSummary),
      p => p.amount,
      record.map(a => (type === 'due' ? a.dueAmount : a.paidAmount)),
      record.filter(a => a > 0)
    ),
    period: pipe(memoed.extract(s.home.currentPeriodSummary), p => p.period),
  }))

  return (
    <StatisticWithDate
      amountTitle={
        type === 'paid' ? (
          <FormattedMessage id="paidInvoices" />
        ) : (
          <FormattedMessage id="dueInvoices" />
        )
      }
      loading={loading}
      period={period}
      amount={amount}
    />
  )
}

export default AmountCard
